import {Trans} from '@lingui/macro';
import React from 'react';

import {AccordionSectionData} from '../../../../../components/common/accordion/accordionSection';
import {buildRuleEditorFaqSections, RuleEditorRecipeFaq} from '../helpers/ruleEditorRecipeFaq';

/*
 * Props.
 */

interface CsatEditorSidebarProps {}

/*
 * Components.
 */

export const CsatEditorSidebar: React.FC<CsatEditorSidebarProps> = () => (
  <RuleEditorRecipeFaq sections={getCsatFaqSections()} />
);

/*
 * Helpers.
 */

function getCsatFaqSections(): ReadonlyArray<AccordionSectionData> {
  const sections = [
    {
      title: <Trans id="csat-editor-sidebar-item-1-title">What are customer satisfaction ratings?</Trans>,
      content: (
        <Trans id="csat-editor-sidebar-item-1-content">
          Satisfaction ratings are used to collect feedback from customers on your service or product. This
          template sends surveys automatically.
        </Trans>
      ),
    },
    {
      title: <Trans id="csat-editor-sidebar-item-2-title">Which channels are supported?</Trans>,
      content: (
        <Trans id="csat-editor-sidebar-item-2-content">
          You can use email, SMS, and chat-based channels.
        </Trans>
      ),
    },
    {
      title: <Trans id="csat-editor-sidebar-item-3-title">How does the timer work?</Trans>,
      content: (
        <Trans id="csat-editor-sidebar-item-3-content">
          A timer is triggered after a conversation is archived, and a reply is sent after the timer expires.
          If a new inbound arrives or a conversation is reopened, the timer is canceled and only restarted
          when the conversation is archived again.
        </Trans>
      ),
    },
    {
      title: <Trans id="csat-editor-sidebar-item-4-title">How are teammates given credit?</Trans>,
      content: (
        <Trans id="csat-editor-sidebar-item-4-content">
          The last teammate who replied to the customer is associated with the CSAT rating.
        </Trans>
      ),
    },
    {
      title: <Trans id="csat-editor-sidebar-item-5-title">How can I prevent a survey from going out?</Trans>,
      content: (
        <Trans id="csat-editor-sidebar-item-5-content">
          A survey won’t be sent multiple times on the same conversation. To prevent any given survey from
          going out, remove the “Survey Scheduled” tag from the conversation.
        </Trans>
      ),
    },
    {
      title: <Trans id="csat-editor-sidebar-item-6-title">How do I track performance?</Trans>,
      content: (
        <Trans id="csat-editor-sidebar-item-6-content">
          Individual responses are posted as comments in the conversation, and overall results will be visible
          in Analytics in the Customer Satisfaction report.
        </Trans>
      ),
    },
  ];

  return buildRuleEditorFaqSections(sections);
}
